/* eslint-disable react/prop-types */
import { Avatar, Card, Divider, Link, Stack, Typography } from "@mui/material";
import NextLink from 'next/link';
import Image from "../../components/Image";
import TextMaxLine from "../../components/TextMaxLine";

export default function LicenseTypeItem({ item }) {
  const { title, orderNo, slug, description, metaDescription } = item;

  function urlify(text) {
    var anchors = /<img\s[^>]*?src=(["']?)([^\s]+?)\1[^>]*?>/ig;
    var links = [];
    text.replace(anchors, function (_anchor, _quote, url) {
      links.push(url);
    });

    return links?.[0];
  }

  var imagePath = urlify(description);

  return (
    <NextLink href={`/thi-sa-hinh/${slug}`} passHref>
      <Link color="inherit" underline="none">
        <Card >
          <Stack spacing={2.5} pb={2}>
            <Image alt="preview" src={imagePath} sx={{ height: 200 }} />
            <Stack direction="row" alignItems="center" spacing={2} px={1}>
              <Avatar alt={`${orderNo}`} sx={{ bgcolor: '#78a6ff', color: '#fff', fontWeight: 600 }} >{title.substring(title.length - 2).trim()}</Avatar>
              <Typography variant="subtitle1" textTransform={"capitalize"}>{title}</Typography>
            </Stack>
            <Divider />
            <TextMaxLine variant={'body2'} line={3} persistent px={1}>
              {metaDescription}
            </TextMaxLine>
          </Stack>
        </Card>
      </Link>
    </NextLink>
  );
}
